export default __webpack_public_path__ + "static/media/Bandit_Particle.c82828c2.png";